import { useEffect, useRef, useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

const FACTION_OPTIONS = [
  { id: "ECSU", label: "ECSU", description: "건설 / 장기전" },
  { id: "GO", label: "GO", description: "속도 / 기습" },
  { id: "SB", label: "SB", description: "자원 / 화력" },
] as const;

type FactionOption = (typeof FACTION_OPTIONS)[number]["id"];
type FirstSeat = "host" | "guest";

export function TriAngerCreateGameForm({
  onConfigChange,
}: CreateGameFormProps) {
  const [hostFaction, setHostFaction] = useState<FactionOption>("ECSU");
  const [guestFaction, setGuestFaction] = useState<FactionOption>("GO");
  const [firstSeat, setFirstSeat] = useState<FirstSeat>("host");
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;

  useEffect(() => {
    onConfigChangeRef.current({
      hostFaction,
      guestFaction,
      firstSeat,
    });
  }, [hostFaction, guestFaction, firstSeat]);

  function updateHostFaction(nextFaction: FactionOption): void {
    setHostFaction(nextFaction);
    if (nextFaction === guestFaction) {
      setGuestFaction(nextFaction === "GO" ? "SB" : "GO");
    }
  }

  function updateGuestFaction(nextFaction: FactionOption): void {
    setGuestFaction(nextFaction === hostFaction ? guestFaction : nextFaction);
  }

  return (
    <section className="rounded-md border border-border-subtle bg-surface-secondary p-3">
      <div className="mb-3">
        <div className="font-semibold text-sm text-text-primary">
          Tri-Anger 설정
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        <label className="grid gap-1.5 text-sm">
          <span className="font-semibold text-text-secondary">방장 팩션</span>
          <select
            value={hostFaction}
            onChange={(event) =>
              updateHostFaction(event.currentTarget.value as FactionOption)
            }
            className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          >
            {FACTION_OPTIONS.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label} - {option.description}
              </option>
            ))}
          </select>
        </label>
        <label className="grid gap-1.5 text-sm">
          <span className="font-semibold text-text-secondary">참가자 팩션</span>
          <select
            value={guestFaction}
            onChange={(event) =>
              updateGuestFaction(event.currentTarget.value as FactionOption)
            }
            className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          >
            {FACTION_OPTIONS.map((option) => (
              <option
                key={option.id}
                disabled={option.id === hostFaction}
                value={option.id}
              >
                {option.label} - {option.description}
              </option>
            ))}
          </select>
        </label>
        <label className="grid gap-1.5 text-sm">
          <span className="font-semibold text-text-secondary">선공</span>
          <select
            value={firstSeat}
            onChange={(event) =>
              setFirstSeat(event.currentTarget.value as FirstSeat)
            }
            className="rounded-md border border-border-primary bg-surface-primary px-3 py-2 text-text-primary"
          >
            <option value="host">방장</option>
            <option value="guest">참가자</option>
          </select>
        </label>
      </div>
    </section>
  );
}
